import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-4">
      <div className="bg-background border border-border rounded-lg p-8 max-w-md w-full text-center space-y-3">
        <div className="text-5xl font-bold text-muted-foreground">404</div>
        <h1 className="text-lg font-semibold">页面不存在</h1>
        <p className="text-sm text-muted-foreground">
          你访问的链接可能已被删除、移动，或从未存在过。
        </p>
        <Link
          to="/"
          className="inline-block mt-2 rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:opacity-90"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}
